import styled from "styled-components";
import { Button } from "../../atoms/Button";
import { CardTemplate } from "../../templates/CardTemplate";
import { useEmailSend } from "./hook";

export const EmailSendPage: React.FC = () => {
  const {
    maskedEmail,
    handleEmailSend,
  } = useEmailSend();

  return (
    <CardTemplate title="メール送信">
      <StyledDescriptionContainer>
        <StyledTextContainer>
          指定したメールアドレスをご確認してください。以下のメールアドレスに認証番号を送信します。メールアドレスが間違っている場合は、システム管理者に連絡してください。
        </StyledTextContainer>

        <StyledEmailContainer>
          <StyledTextContainer>メールアドレス</StyledTextContainer>

          <StyledEmailText>{maskedEmail}</StyledEmailText>
        </StyledEmailContainer>
      </StyledDescriptionContainer>

      <Button text="送信" variant="filled" onClick={handleEmailSend} fullWidth />
    </CardTemplate>
  );
};

const StyledDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`;

const StyledEmailContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 260px;
  height: 30px;
`;

const StyledEmailText = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 150%;
`;

